import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createVendors(data) {
  return axiosInstance.post(`vendors/create`, formatRequest(data));
}

export function updateVendors(data) {
  return axiosInstance.post(`vendors/update`, formatRequest(data));
}

export function getVendorsList(data) {
  return axiosInstance.post(`vendors/list`, formatRequest(data));
}

export function getVendorsDetails(data) {
  return axiosInstance.post(`vendors/details`, formatRequest(data));
}

export function deleteVendors(data) {
  return axiosInstance.post(`vendors/delete`, formatRequest(data));
}
